import styled from 'styled-components';

import { WithThemeProps, lighten } from '../../styles';


const Root = styled.div`
	position: relative;
`;

const SeenecoLogoLayout = styled.div`
	width: 80px;
	height: 70px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	background-color: #485366;

	${(p: WithThemeProps) => `
		background-color: ${lighten(p.theme.color.bgDark, 0.1)};
	`}
`;

export {
	Root,
	SeenecoLogoLayout
}
